import React, { useEffect } from 'react';
import { stationsMaster } from '../data/stations';
import { externalLinkBaseUrl } from '../services/urlService';
import { eventsEmit, lineNameAbbr } from '../services/appboxService';
import closeIcon from '../assets/images/trains/kinds/ic_close_dialog.svg'
import externalLinkIcon from '../assets/images/stations/transfers/ic_external_link.svg';

const Transfer = (props) => {
  useEffect(() => {
    import('../assets/stylesheets/stations/transfers.css')
      .then(() => {})
      .catch(err => console.error("CSSの読み込みエラー", err));

    eventsEmit(`other_line_transfer.screen.${props.match.params.station_id}`, {});
  }, []);

  const clickCloseButton = () => {
    eventsEmit('other_line_transfer.close', {});
    window.history.back();
  };

  const clickTransferStation = (linkUrl, line_name) => {
    eventsEmit('other_line_transfer.line_name', { station: station.stationId, line_name: lineNameAbbr(line_name) });
    location.href = linkUrl;
  };

  const station = stationsMaster.find(s => s.stationId == props.match.params.station_id);

  const modalHeader = (
    <div className="modal-header">
      <h2 className="guide-title">乗り換え</h2>
      <div className="modal-close">
        <button
          className="close-button"
          type='button'
          onClick={ () => clickCloseButton() }
        >
          <img src={closeIcon}/>
        </button>
      </div>
    </div>
  )

  const lineBlock = (icon, name, linkUrl) => {
    return (
      <div
        key={name}
        className="transfers-station-icon"
        onClick={ linkUrl ? () => clickTransferStation(linkUrl, name) : undefined }
      >
        {icon
          ? <img src={icon}/>
          : null
        }
        <span>{name}</span>
        {linkUrl
          ? <img src={externalLinkIcon} />
          : null
        }
      </div>
    )
  }

  const companyBlock = (company) => {
    const baseUrl =  externalLinkBaseUrl(company)

    const lines = company.lines.map((line) => {
      const appUrl = line.timeTableUrlFromTrains ? encodeURIComponent(line.timeTableUrlFromTrains) : null
      const timeTableUrl = baseUrl && appUrl ? baseUrl + `&app=${appUrl}` : null
      return lineBlock(line.icon, line.nameTransferLine, timeTableUrl)
    })

    return (
      <div key={company.companyName} className="transfers-station">
        <h3 className="station-company-name">{company.companyName}</h3>
        {lines}
      </div>
    )
  }

  const transferCompanies = station.transferLines.map((company) => { return companyBlock(company) })
  const mainContent = (
    <div className="main-content">
      {transferCompanies}
    </div>
  )

  return (
    <div>
      <main className="main-container">
        <div className="modal">
          <div className="modal-window">
            {modalHeader}
            {mainContent}
          </div>
        </div>
      </main>
    </div>
  )
}

export default Transfer;